import { gql } from '@apollo/client';

export const FARM_GQL = gql`
  query Farm {
    farm(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      name
      id
      organization_id
      organization {
        name
      }
    }
  }
`;

export const GET_USER_NOTIFICATION_TRANSPORT_SETTINGS_GQL = gql`
  query GetUserNotificationTransportSettings($user_id: uuid!) {
    user_notification_transport_settings(where: { user_id: { _eq: $user_id } }) {
      user_id
      sms
      push
      email
    }
  }
`;

export const UPSERT_USER_NOTIFICATION_TRANSPORT_SETTINGS_GQL = gql`
  mutation UpsertUserNotificationTransportSettings($user_id: uuid!, $sms: Boolean!, $push: Boolean!, $email: Boolean!) {
    insert_user_notification_transport_settings(
      objects: { user_id: $user_id, sms: $sms, push: $push, email: $email }
      on_conflict: {
        constraint: user_notification_transport_settings_pkey # or whatever your PK/unique constraint is
        update_columns: [sms, push, email]
      }
    ) {
      affected_rows
      returning {
        user_id
        sms
        push
        email
        __typename
      }
    }
  }
`;
